export const AppEvents = {
    apiLoadingStart: 'api:loading:start',
    apiLoadingStop: 'api:loading:stop',
    authUnauthorized: 'auth:unauthorized',
    dashboardRefresh: 'dashboard:refresh',
    occasionArchived: 'occasion:archived',
} as const;

export type AppEvent = typeof AppEvents[keyof typeof AppEvents];
